// File: frontend/src/components/ui/PageShell.js
//
// Page wrapper: guards against horizontal overflow (minWidth:0) and gives the
// page the full width of the content area. Horizontal page gutters are
// AdminLayout's <main>'s job, so this deliberately adds none.
//
// THE WIDTH RULE (§50). An admin page fills the content area the shell gives
// it — the same available space Dashboard, Financials and every other page use.
// This wrapper used to cap at 1440px, which boxed Business Overview, Sites,
// Topology and Roaming into a narrower column than their neighbours on wide
// screens, for no reason anyone had written down. A cap on LINE LENGTH belongs
// to a block of prose (PageHeader's description caps itself at 640px), not to a
// page of cards and tables. `maxWidth` stays available for a page that has a
// real reason to be narrower; say the reason where it is used.

import React from "react";
import { Box } from "@mui/material";

export default function PageShell({ children, maxWidth = "100%", sx }) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth,
        mx: "auto",
        minWidth: 0,
        boxSizing: "border-box",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
